
import React from "react";
import SideBar from "./SideBar";
import SidePane from "./SidePane"
import DashboardHeader from "../shared-components/DashboardHeader";
import CircleLoader from "react-spinners/CircleLoader";

const Layout = (Component) => {
  return (props) => {
    return (
      <div style={{ display: "flex", minHeight: "100vh" }}>
        {/* <SideBar /> */}
        <SidePane/>
        <div style={{ flex: 1 }}>
          <DashboardHeader />
          <main style={{
            backgroundColor: "#F5F5F5",
            overflowX: "auto",
            padding: "10px",
            borderRadius: "10px",
            margin: "10px",
          }}>
            <Component {...props} />
          </main>
        </div>
      </div>
    );
  };
};

export default Layout;
